export default {
  init() {
  },
  finalize() {
    $('.member-popup-show').on('click', function (e) {
      e.preventDefault();

      let $target = $(this).data('target');

      $('#' + $target).addClass('show');
      $('body').addClass('overflow-hidden');
    });

    $('.popup-close').on('click', function (e) {
      e.preventDefault();

      let $target = $(this).data('target');

      $('#' + $target).removeClass('show');
      $('body').removeClass('overflow-hidden');
    });

    $('.popup-wrapper').on('click', function (e) {
      e.preventDefault();
      if ($(e.target).parents('.popup').length === 0 && !$(e.target).hasClass('popup')) {

        let $target = $(this).find('.popup-close').data('target');

        $('#' + $target).removeClass('show');
        $('body').removeClass('overflow-hidden');
      }
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/templateTeam.js